import { render, staticRenderFns } from "./QuotationsList.vue?vue&type=template&id=06da28a2&scoped=true&"
import script from "./QuotationsList.vue?vue&type=script&lang=js&"
export * from "./QuotationsList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsList.vue?vue&type=style&index=0&id=06da28a2&lang=scss&scoped=true&"
import style1 from "./QuotationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da28a2",
  null
  
)

export default component.exports